import { render, staticRenderFns } from "./TimeToAddingChildInfoModal.vue?vue&type=template&id=75ed248a&scoped=true&"
import script from "./TimeToAddingChildInfoModal.vue?vue&type=script&lang=js&"
export * from "./TimeToAddingChildInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./TimeToAddingChildInfoModal.vue?vue&type=style&index=0&id=75ed248a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ed248a",
  null
  
)

export default component.exports